import { render, staticRenderFns } from "./consumeIndustry.vue?vue&type=template&id=cebfff2e"
import script from "./consumeIndustry.vue?vue&type=script&lang=js"
export * from "./consumeIndustry.vue?vue&type=script&lang=js"
import style0 from "./consumeIndustry.vue?vue&type=style&index=0&id=cebfff2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports